import { render, staticRenderFns } from "./trainingAssignment.vue?vue&type=template&id=7c35f19e&scoped=true"
import script from "./trainingAssignment.vue?vue&type=script&lang=js"
export * from "./trainingAssignment.vue?vue&type=script&lang=js"
import style0 from "./trainingAssignment.vue?vue&type=style&index=0&id=7c35f19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35f19e",
  null
  
)

export default component.exports